import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { useStyle } from '~/providers/StyleProvider'

import { FILTER } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface NoResultsProps {
  className?: string
  title?: string
}

function NoResults({ className, title }: NoResultsProps) {
  const t = useTranslate()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })

  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Haffer,
    color: GlobalThemeColors.MineShaft,
    textStyling: GlobalTextStyling.UpperCase,
  })
  const labelStyle = useStyle({
    textPreset: GlobalTextPreset.Title11_12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  return (
    <div className={cx(className, gridStyle)}>
      <div className={css.wrapper}>
        {title && <p className={titleStyle}>{title}</p>}
        <div className={css.content}>
          <p className={labelStyle}>{t(FILTER.NO_RESULT)}</p>
        </div>
      </div>
    </div>
  )
}

NoResults.defaultProps = {}

export default NoResults
